import {DatevWizardExportDateState} from './datev-wizard-export-date.state';


export const datevWizardExportDateStateInitial: DatevWizardExportDateState = {
  exportDate: undefined,
  exportDateIndependent: undefined,
};
